import { Text } from '@/components'

type Props =
  | {
      isLoading: true
    }
  | {
      percentage: number
      color: string
      isLoading?: false
    }
function SkeletonLoader() {
  return (
    <div className="flex items-center gap-4">
      <div className="flex-1 bg-themed-grey-100 rounded-full h-4 overflow-hidden">
        <div className="h-full bg-themed-grey-300 rounded-full animate-pulse" />
      </div>
      <div className="w-10 h-5 bg-themed-grey-300 rounded animate-pulse" />
    </div>
  )
}

function LoadedProgressBar({
  percentage,
  color,
}: {
  percentage: number
  color: string
}) {
  return (
    <div className="flex items-center gap-4">
      <div className="flex-1 bg-themed-grey-100 rounded-full h-4 overflow-hidden">
        <div
          className={`h-full transition-all duration-500 ease-out ${color} rounded-full`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <Text variant="subheader" className="text-themed-grey-500">
        {Math.round(percentage)}%
      </Text>
    </div>
  )
}

export function BatteryProgressBar(props: Props) {
  if (props.isLoading) {
    return <SkeletonLoader />
  }

  return <LoadedProgressBar percentage={props.percentage} color={props.color} />
}
